import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import React from 'react'
import styled from 'styled-components'

const Container = styled(VerticalSpacer)`
  position: relative;
  grid-area: pricing;

  ${mediaQueryUp.tablet} {
    justify-self: end;
    width: ${rem(250)};
  }
`

function AccommodationPackageTilePricingArea(props: PropsWithChildren) {
  return <Container
    {...props}
    gap={12}
  />
}

export default AccommodationPackageTilePricingArea
